import { z } from "zod";
export const errorEnvelopeSchema = z.object({
    error: z.object({
        code: z.string(),
        message: z.string(),
        details: z.record(z.unknown()).optional(),
    }),
});
const HTTP_STATUS = {
    bad_request: 400,
    unauthorized: 401,
    forbidden: 403,
    not_found: 404,
    conflict: 409,
    validation_failed: 422,
    rate_limited: 429,
    not_implemented: 501,
    internal: 500,
};
export class ApiError extends Error {
    code;
    statusCode;
    details;
    constructor(code, message, details) {
        super(message);
        this.name = "ApiError";
        this.code = code;
        this.statusCode = HTTP_STATUS[code];
        this.details = details;
    }
    toEnvelope() {
        return {
            error: {
                code: this.code,
                message: this.message,
                ...(this.details ? { details: this.details } : {}),
            },
        };
    }
}
//# sourceMappingURL=errors.js.map